module.exports = __webpack_public_path__ + "static/media/Metso-Contender-Series.d5e81c98.png";